<template>
  <div class="s-foot-bg">
    <div class="s-foot-box">
      <div class="s-foot-l">
        <!-- <div class="foot-l-h">
					<img src="../assets/images/foot/logo.png" />
				</div>
				<div class="foot-l-p">关注我们</div>
				<div class="foot-l-ul" @mouseleave="outFootMouse">
					<div class="foot-l-li" v-for="(item,index) in footList" :key="index">
						<div class="foot-l-cell" @mouseenter="footMouseOver(index)">
							<img :src="item.url" />
						</div>
						<div :class="['foot-l-code',item.isSet]">
							<img :src="item.code" />
						</div>
					</div>
				</div> -->
        <img src="../assets/images/foot/foot-left.jpg" />
      </div>
      <div class="s-foot-r">
        <div class="s-foot-span">
          <div class="s-foot-h">AI大模型</div>
          <div class="s-foot-p" @click="gotoUrl(0)">安全防护网</div>
          <div class="s-foot-p" @click="gotoUrl(1)">后台展示</div>
          <div class="s-foot-p" @click="gotoUrl(2)">解决方案</div>
        </div>
        <div class="s-foot-span webNot">
          <div class="s-foot-h">产品介绍</div>
          <div class="s-foot-p" @click="gotoProduct(1)">电动自行车充电桩</div>
          <div class="s-foot-p" @click="gotoProduct(3)">智慧照明</div>
        </div>
        <div class="s-foot-span">
          <div class="s-foot-h">服务支持</div>
          <div class="s-foot-p" @click="gotoService(0)">常见问题</div>
          <div class="s-foot-p" @click="gotoService(1)">安装申请</div>
          <div class="s-foot-p">
            <a href="http://oms.issks.com/skoms/#/login" target="_blank">
              运营商后台登录
            </a>
          </div>
        </div>
        <div class="s-foot-span webNot" @click="gotoNews">
          <div class="s-foot-h">新闻中心</div>
          <div class="s-foot-p">新闻动态</div>
        </div>
        <div class="s-foot-span" @click="gotoContact">
          <div class="s-foot-h">关于闪开</div>
          <div class="s-foot-p">企业文化</div>
          <div class="s-foot-p">发展历程</div>
          <div class="s-foot-p">联系我们</div>
        </div>
      </div>
    </div>
    <div class="s-foot-title">
      <p>
        版权所有 嘉兴智行物联网技术有限公司 Copyright 2017.Al Rights Reserved
      </p>
      <p>
        <img src="../assets/images/logobc.png" class="baImgcs" />
        <a
          class="jgawb"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33049802000396"
          target="_blank"
          data-v-08a5779c=""
          style="color: rgb(116, 154, 227) !important"
        >
          &nbsp;浙公网安备33049802000396号</a
        >&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/ "
          >浙ICP备15017943号-1</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      footList: [
        {
          isSet: "",
          url: require(`@/assets/images/foot/tab1.png`),
          code: require(`@/assets/images/foot/tab1s.jpg`),
        },
        {
          isSet: "",
          url: require(`@/assets/images/foot/tab2.png`),
          code: require(`@/assets/images/foot/tab2s.jpg`),
        },
        {
          isSet: "",
          url: require(`@/assets/images/foot/tab3.png`),
          code: require(`@/assets/images/foot/tab3s.jpg`),
        },
        {
          isSet: "",
          url: require(`@/assets/images/foot/tab4.png`),
          code: require(`@/assets/images/foot/tab4s.jpg`),
        },
      ],
    };
  },
  //初始化执行
  mounted() {
    //此处代替onLoad
    var self = this;
  },
  methods: {
    //跳转页面
    gotoUrl(index) {
      this.$router.push({ path: "/AI", query: { anchor: index } });
      // var self = this;
      //   var url = "";
      //   if (index == 1) {
      //     url = "/AI";
      //     this.$router.push({ path: url });
      //   } else if (index == 2) {
      //     url = "/AI";
      //     this.$router.push({ path: url });
      //   } else if (index == 3) {
      //     url = "/AI";
      //     this.$router.push({ path: url, query: { tabId: 2, productId: 0 } });
      //   }
    },
    //显示二维码
    footMouseOver(index) {
      var self = this;
      for (var i in self.footList) {
        if (self.footList[i].isSet) {
          self.footList[i].isSet = "";
        }
      }
      var obj = self.footList[index];
      obj.isSet = "select";
    },
    outFootMouse() {
      var self = this;
      for (var i in self.footList) {
        if (self.footList[i].isSet) {
          self.footList[i].isSet = "";
        }
      }
    },
    gotoProduct(index) {
      var self = this;
      var url = "/product";
      var id = 0;
      var num = 0;
      if (index == 1) {
        id = 0;
        num = 1;
      } else if (index == 2) {
        id = 1;
        num = 4;
      } else if (index == 3) {
        id = 1;
        num = 0;
      }
      this.$router.push({ path: url, query: { tabId: id, productId: num } });
    },
    gotoService(anchor) {
      var self = this;
      this.$router.push({ path: "/service", query: { anchor: anchor } });
    },
    gotoNews() {
      var self = this;
      this.$router.push({ path: "/news" });
    },
    gotoContact() {
      this.$router.push({ path: "/contact" });
    },
  },
};
</script>

<style>
.s-foot-bg {
  width: 100%;
  background-color: #333333;
  /* background: url('../assets/images/foot/footBg.jpg') no-repeat; */
  /* background-size: 100% 100%; */
}
.foot-l-ul {
  margin-top: 1vw;
  display: flex;
  align-items: center;
}
.foot-l-li {
  width: 10%;
  position: relative;
}
.foot-l-cell {
  width: 70%;
  margin: 0 auto;
}
.foot-l-code {
  width: 240%;
  opacity: 0;
  position: absolute;
  top: 100%;
  left: -60%;
  z-index: 9;
}
.foot-l-code.select {
  opacity: 1;
}
.foot-l-h {
  width: 70%;
}
.foot-l-p {
  margin-top: 1vw;
  color: #fff;
  text-align: left;
  font-size: 1.2vw;
  font-weight: 900;
}
@media screen and (max-width: 750px) {
  .s-foot-bg {
    padding-top: 1rem;
  }
  .s-foot-box {
    width: 100%;
    padding: 0.5rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .s-foot-l {
    width: 30%;
  }
  .s-foot-r {
    display: flex;
    justify-content: center;
    flex-flow: wrap;
    color: #fff;
  }
  .s-foot-span {
    margin: 0 0.5rem;
  }
  .s-foot-span.webNot {
    display: none;
  }
  .s-foot-h {
    font-size: 0.7rem;
    font-weight: bold;
    text-align: left;
  }
  .s-foot-p {
    margin-top: 1rem;
    text-align: left;
    font-size: 0.6rem;
    cursor: pointer;
  }
  .s-foot-p a {
    color: #fff;
    text-decoration: none;
  }
  .s-foot-title {
    padding: 0.5rem 0;
    background-color: #303030;
    font-size: 0.8rem;
    text-align: center;
    color: rgba(255, 255, 255, 0.6);
  }
  /* =============== */
  .foot-l-p {
    margin-top: 1rem;
    font-size: 0.8rem;
  }
  .foot-l-li {
    width: 20%;
  }
}
/* =======PC样式========= */
@media screen and (min-width: 755px) {
  .s-foot-bg {
    padding: 1;
  }
  .s-foot-box {
    padding: 1.5vw 16%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .s-foot-l {
    width: 15%;
    margin-right: 6vw;
  }
  .s-foot-l img {
  }
  .s-foot-r {
    display: flex;
    justify-content: center;
    color: #fff;
  }
  .s-foot-span {
    margin: 0 2vw;
  }
  .s-foot-h {
    font-size: 1vw;
    font-weight: bold;
    text-align: left;
  }
  .s-foot-p {
    margin-top: 1vw;
    text-align: left;
    font-size: 0.8vw;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
  }
  .s-foot-p a {
    color: rgba(255, 255, 255, 0.6);
    text-decoration: none;
  }
  .s-foot-title {
    padding: 0.5vw 0;
    font-size: 0.8vw;
    background-color: #303030;
    text-align: center;
    color: rgba(255, 255, 255, 0.6);
  }
}
.s-foot-title p {
  display: flex;
  justify-content: center;
  align-items: center;
}
.s-foot-title p a {
  color: rgba(255, 255, 255, 0.6);
}
.baImgcs {
  width: 20px;
}
</style>
